import React from 'react'
import { Button } from 'reactstrap'
import { BiEditAlt, BiTrash, BiFolder } from 'react-icons/bi'
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs'

// Folder-page chrome: a breadcrumb trail ("‹ {Parent} › {Folder}"), the folder
// name + "N {noun} in this folder" count, and the Add existing / Rename / Delete
// actions. The folder's rows are rendered in place by the host list screen (its
// own table, filtered to this folder's items), so this header sits above it.
const FolderDetailView = ({
  folder,
  itemCount,
  itemNoun,
  parentLabel,
  isAdmin,
  onBack,
  onAddExisting,
  onRename,
  onDelete,
}) => {
  if (!folder) {
    return null
  }

  const count = itemCount || 0
  const noun = itemNoun || 'items'
  const singularNoun = count === 1 ? noun.replace(/s$/, '') : noun
  const countText =
    count === 0
      ? `No ${noun} in this folder`
      : `${count} ${singularNoun} in this folder`

  return (
    <div className="folder-detail-header mt-2">
      <Breadcrumbs
        className="mb-2"
        crumbs={[
          { label: parentLabel || 'Back', onClick: onBack },
          { label: folder.name },
        ]}
      />
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <div className="d-flex align-items-center">
          <div className="folder-detail-icon-box mr-3">
            <BiFolder className="folder-detail-icon-glyph" />
          </div>
          <div className="d-flex flex-column">
            <span className="folder-detail-title">{folder.name}</span>
            <span className="folder-detail-count">{countText}</span>
          </div>
        </div>

        {isAdmin ? (
          <div className="d-flex align-items-center flex-wrap folder-detail-actions mt-2">
            <Button
              className="folder-btn-outline mr-2"
              size="sm"
              onClick={() => {
                if (onAddExisting) {
                  onAddExisting()
                }
              }}
            >
              + Add {noun}
            </Button>
            <Button
              className="folder-detail-action-btn mr-2"
              size="sm"
              onClick={() => {
                if (onRename) {
                  onRename()
                }
              }}
            >
              <BiEditAlt /> Rename
            </Button>
            <Button
              className="folder-detail-action-btn folder-detail-action-btn--delete"
              size="sm"
              onClick={() => {
                if (onDelete) {
                  onDelete()
                }
              }}
            >
              <BiTrash /> Delete
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default FolderDetailView
